import moment from 'moment';
import * as yup from 'yup';

import { FIELDS } from 'store/insuranceAnketa/constants';

import {
  OUTPUT_CUSTOMER_DATE_FORMAT,
  VALIDATION_TYPES,
  VOID_VALIDATION,
} from './Insurance.constants';

export const CUSTOMER_BIRTHDATE_SCHEMA = yup
  .mixed()
  .test(VALIDATION_TYPES.REQUIRED, 'Введите дату рождения', Boolean)
  .test(VALIDATION_TYPES.INCORRECT, 'Минимальный возраст 18 лет', (value) => {
    const lastValidDate = moment().subtract(18, 'years');
    const bd = moment(value, OUTPUT_CUSTOMER_DATE_FORMAT);

    const diff = lastValidDate.diff(bd);

    return diff >= 0;
  });

export const CUSTOMER_DRIVING_EXPERIENCE_SCHEMA = yup
  .mixed()
  .test(VALIDATION_TYPES.REQUIRED, 'Введите стаж вождения', (value) => {
    return !value || typeof value === 'number';
  });

export const CUSTOMER_DRIVING_LICENSE_ISSUE_DATE_SCHEMA = yup
  .mixed()
  .test(VALIDATION_TYPES.REQUIRED, 'Введите дату выдачи', Boolean)
  .test(VALIDATION_TYPES.INCORRECT, 'Не может превышать 10 лет + 3 года продления', (value) => {
    const lastValidDate = moment().subtract(10, 'years');
    const currentLicenseDate = moment(value, OUTPUT_CUSTOMER_DATE_FORMAT);
    // Срок действия водительских удостоверений продлен на три года
    const extension = [3, 'years'];
    const extensionLicenseDate = currentLicenseDate.clone().add(...extension);
    // Продление начало действовать на водительске удостовереня выпущенные с 01.01.2012
    const FIRST_EXTENSION_DATE = moment('01/01/2012', 'DD/MM/YYYY');
    const isValidLicense = FIRST_EXTENSION_DATE.diff(currentLicenseDate) <= 0;

    const diff = lastValidDate.diff(extensionLicenseDate);

    return diff <= 0 && isValidLicense;
  })
  .when(FIELDS.BIRTHDATE, {
    is: Boolean,
    then: yup
      .mixed()
      .test(VALIDATION_TYPES.INCORRECT, 'Не может быть меньше 16 лет', function (value) {
        const { [FIELDS.BIRTHDATE]: birthdate } = this.parent;

        const lastValidDate = moment(birthdate, OUTPUT_CUSTOMER_DATE_FORMAT).add(16, 'years');
        const currentLicenseDate = moment(value, OUTPUT_CUSTOMER_DATE_FORMAT);

        const diff = lastValidDate.diff(currentLicenseDate);

        return diff <= 0;
      }),
    otherwise: VOID_VALIDATION,
  });

export const CUSTOMER_DRIVING_LICENSE_SERIES_AND_NUMBER_SCHEMA = yup
  .string()
  .required('Введите серию и номер')
  .matches(/^([\d]{2}(([\d]{2})|([а-яА-ЯёЁ]{2}))\s[\d]{6})$/, 'Некорректная серия или номер');

export const CUSTOMER_FULL_NAME_SCHEMA = yup
  .string()
  .required('Введите ФИО')
  .matches(/[А-Яа-яёЁ-]+\s[А-Яа-яёЁ-]+(\s[А-Яа-яёЁ-]+)?/, 'Неверное ФИО');
